import e from "./atoms-v21143.js";
import m from "./atoms-v21147.js";
import n from "./atoms-v21145.js";
function f(r, t) {
  n(2, arguments);
  var o = e(t);
  return m(r, -o);
}
export {
  f as default
};
